<!-- eslint-disable -->
<template lang="pug">
    svg(:width="elemWidth" height="40" xmlns="http://www.w3.org/2000/svg")
        path(:d="generatePath(elemWidth)" fill="none" stroke="black")
</template>

<script>
/*eslint-disable*/

export default {
    props: {
        elemWidth: {
            type: Number,
            default: 60,
        },
    },
    methods: {
        generatePath(elemWidth) {
            return `M1 39L${elemWidth/2.1} 1L${elemWidth - 1} 39`;
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
